import { Box,Spacer } from "@chakra-ui/react";


export default function Findkfc(){
    return (
        <Box>
            <Spacer h={"150px"}/>
            Find A kfc
        </Box>
    )
}